import btoa from "btoa";

export const NUMBERS = '0123456789'
export const UPPER_CASE_LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
export const LOWER_CASE_LETTERS = 'abcdefghijklmnopqrstuvwxyz'
export const SPECIAL_CHARACTERS = "!'^+%&/()=?_#$½§{[]}|;:>÷`<.*-@é"
export const PASSWORD_LENGTH = 10
export const CRYPTO_SECRET_KEY = 'bt@pp#secret$key'
export const UNEXPECTED_ERROR = 'An unexpected error has occured'
export const BAD_REQUEST = 'Bad Request'
export const FAILED = 'failed';
export const INVALID_CREDENTIALS = 'InvalidCredentials'
export const TIMEOUT = 'Gateway Timeout'
export const USER_ALREADY_EXISTS = "UserAlreadyExists"
export const INVALID_COMMUNICATION_ID = "InvalidCommunicationId"
export const INVALID_CHANNEL_ID = "InvalidChannelId"
export const RESOURCE_NOT_FOUND = "ResourceNotFound"
export const BT_TRANSACT = "brighttalk-transact"